export default __webpack_public_path__ + "static/media/press_room_thumb2.b4e69cfb.png";